module.exports = __webpack_public_path__ + "media/images/client-21-c24d148a57b300d826a43df800240446.png";